import FAQ3 from './FAQ3'
export default FAQ3
